export default function standardResult() {
    return {
        scope: true,
        replace: true,
        restrict: 'EA',
        template:
            `<li data-type="{{ ::result.resultType }}" data-rel="{{ ::$index }}">
               <a href="{{ result.url}}" class="search-result-link">
                   <h5 ng-bind="::result.name"></h5>
               </a>
               <small class="path" ng-bind="::result.url"></small>
               <p ng-bind="::result.description" ng-if="::result.description"></p>
               <p ng-bind="::result.summary" ng-if="::result.summary"></p>
               <p class="footnote" ng-if="result.resultType === \'policyitem\'" ng-bind="::result.date"></p>
            </li>`
    };
}